import React, { FC, ReactNode } from "react";
import {
    ButtonCell as TgButtonCell,
    type ButtonCellProps as TgButtonCellProps,
} from "@telegram-apps/telegram-ui";
import clsx from "clsx";

export interface ButtonCellProps extends TgButtonCellProps {
    children?: ReactNode;
}

export const ButtonCell: FC<ButtonCellProps> = (props) => {
    return (
        <TgButtonCell
            {...props}
            className={clsx(
                "block w-full p-0 h-auto m-0 text-inherit text-left",
                props.className
            )}
        >
            {props.children}
        </TgButtonCell>
    );
};
